import {
  generatePath,
  LoaderFunction,
  Outlet,
  redirect,
} from "react-router-dom";
import { pathname } from "#src/config/pathname";
import store from "#src/store";
import workspaceServices from "#src/services/workspace";
import { authService } from "#src/services/auth";
import {
  selectWorkspace,
  updateWorkspaceList,
} from "#src/store/slices/workspace";
import { apiErrorHandler } from "#src/utils/apiErrorHandler";

export const homePageLoader: LoaderFunction = async () => {
  const authToken = authService.accessToken();
  if (!authToken) return redirect(pathname.LOGIN);

  // fetch workspace list, if it's empty, navigate to new workspace
  const workspaceList = await workspaceServices
    .list_workspaces()
    .catch(apiErrorHandler);

  // Update workspaceList on Redux store
  store.dispatch(updateWorkspaceList(workspaceList));

  if (workspaceList && workspaceList.length >= 1) {
    store.dispatch(selectWorkspace(workspaceList[0].id));
    return redirect(
      generatePath(pathname.SOLUTIONS, { workspaceId: workspaceList[0].id })
    );
  } else {
    return redirect(pathname.NEW_WORKSPACE);
  }
};

/** A route used for rerouting. If we don't know where to redirect, put it here? */
export const HomePage = () => {
  // TODO: initialize language
  return <Outlet />;
};
